var _g;
import * as React from "react";
var SvgBookingCustom = function SvgBookingCustom(props) {
  return _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#A0D911",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.654 18.111h-3.05v-3.646c0-.777.3-1.196.97-1.28h2.091a2.272 2.272 0 0 1 2.451 2.457c0 1.555-.938 2.481-2.45 2.481l-.012-.012ZM8.599 8.254v-.957c0-.837.358-1.243 1.136-1.291H11.3c1.339 0 2.152.8 2.152 2.152 0 1.016-.55 2.212-2.092 2.212H8.61l-.012-2.116Zm6.958 3.646-.55-.31.478-.42c.562-.477 1.495-1.565 1.495-3.437 0-2.869-2.224-4.722-5.661-4.722H6.955a1.913 1.913 0 0 0-1.847 1.895v16.26h6.288c3.826 0 6.29-2.08 6.29-5.308 0-1.734-.796-3.229-2.14-3.976l.011.018ZM18.678 18.984c0-1.213.974-2.194 2.182-2.194 1.207 0 2.194.98 2.194 2.194s-.98 2.194-2.194 2.194a2.181 2.181 0 0 1-2.182-2.194"
  }))));
};
export default SvgBookingCustom;